/**
  Author: Lokech Arora - lokesh.arora@enabledata.com
  Purpose: Clients model actions
  Date: May 2020
**/

import { action, thunk } from 'easy-peasy';
import * as customizeService from '../../services/customize';

const customizeModel = {
  configData: {},
  setConfigData: action((state, payload) => {
    state.configData = payload;
  }),
  getConfigData: thunk(async (actions, payload) => {
    return await customizeService
      .getConfigData(payload)
      .then(function (response) {
        actions.setConfigData(response.data.data.config);
        return response;
      })
      .catch(function (error) {
        actions.setConfigData({});
        return error;
      });
  }),
};

export default customizeModel;
